import properties from '../modules/ajio-util/properties';

const assetUrl = properties.getProperty('assetUrl');

const isProd = process.env.NODE_ENV === 'production';

const getWebpackPublicPath = () => (isProd ? `${assetUrl}/static/assets/` : `${assetUrl}/`);

export default getWebpackPublicPath;
